import React, { useState } from 'react';

interface Tab {
    id: string;
    title: string;
    content: React.ReactNode;
}

interface TabProps {
    tabs: Tab[];
    defaultActiveTab?: string;
}

const Tab: React.FC<TabProps> = ({
    tabs,
    defaultActiveTab,
}) => {
    const [activeTab, setActiveTab] = useState(defaultActiveTab || tabs[0]?.id || '');

    const activeTabContent = tabs.find(tab => tab.id === activeTab)?.content;

    return (
        <div className="flex flex-col">
            {/* Top Navigation Bar - Made sticky and flush */}
            <div className="sticky top-0 bg-white dark:bg-gray-800 border-b border-primary dark:border-gray-700 z-[1]">
                <div className="px-4 py-2">
                    {/* Tab Navigation */}
                    <div className="flex space-x-1 overflow-x-auto">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`px-4 py-2 text-sm font-medium cursor-pointer whitespace-nowrap
                          focus:outline-none rounded-t-md transition-colors
                          ${activeTab === tab.id
                                        ? 'text-primary-600 dark:text-primary-400 bg-gray-50 dark:bg-gray-700 border-b-2 border-primary-600 dark:border-primary-400'
                                        : 'text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 hover:bg-gray-50 dark:hover:bg-gray-700'
                                    }`}
                            >
                                {tab.title}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Tab Content */}
            <div className="w-full">
                <div className="w-full">
                    <div className="space-y-6 p-4">
                        {activeTabContent}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tab;